import React from "react"
import "./HomePostContentTitle.scss"

const HomePostContentTitle = ({ title }) => (
    <h3 className="Home__post__content__title">{title}</h3>
)

export default HomePostContentTitle